"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var safe_json_stringify_1 = __importDefault(require("safe-json-stringify"));
var server_logger_1 = require("./server-logger");
var Logger = /** @class */ (function () {
    function Logger(config) {
        var _this = this;
        this.defaultFormatter = function (logLevel, message, details, messageOptions, next) {
            if (messageOptions.skipDefaultFormatter) {
                return next();
            }
            if (message instanceof Error) {
                details = details || message;
                message = message.message;
            }
            var prefix = _this.config.appName ? "[" + _this.config.appName + "] " : '';
            message = "" + prefix + message;
            next(logLevel, message, details, messageOptions);
        };
        this.logMessage = function (logLevel, message, details, messageOptions) {
            if (!messageOptions.skipSecondaryLogger) {
                try {
                    /* log to secondary logger (default is console) */
                    var params = [message];
                    if (typeof details !== 'undefined') {
                        params.push(_this.config.stringify ? safe_json_stringify_1.default(details) : details);
                    }
                    /* eslint-disable-next-line prefer-spread */
                    _this.secondaryLogger[logLevel].apply(_this.secondaryLogger, params);
                }
                catch (error) {
                    /* don't let custom logger errors stop our logger */
                    console.error('Error logging using custom logger passed into `genesys-cloud-client-logger`', { error: error, secondaryLogger: _this.secondaryLogger, message: message, details: details, messageOptions: messageOptions });
                }
            }
            /* log to the server */
            if (!messageOptions.skipServer &&
                _this.serverLogger &&
                _this.logRank(logLevel) >= _this.logRank(_this.config.logLevel)) {
                _this.serverLogger.addLogToSend(logLevel, message, details);
            }
        };
        Object.defineProperty(this, 'clientId', {
            value: uuid_1.v4(),
            writable: false
        });
        this.config = __assign({}, config);
        this.secondaryLogger = this.config.logger || console;
        delete this.config.logger;
        if (this.logRank(this.config.logLevel) === -1) {
            if (config.logLevel) {
                this.warn("Invalid log level: \"" + config.logLevel + "\". Default \"info\" will be used instead.", null, { skipServer: true });
            }
            this.config.logLevel = 'info';
        }
        /* do this for (unofficial) backwards compat */
        if (!config.appName && config.logTopic) {
            this.warn('`logTopic` has been renamed to `appName`. Please use `appName`', null, { skipServer: true });
            this.config.appName = config.logTopic;
        }
        /* default to always set up server logging */
        if (this.config.initializeServerLogging !== false) {
            this.serverLogger = new server_logger_1.ServerLogger(this);
        }
    }
    Logger.prototype.setAccessToken = function (token) {
        this.config.accessToken = token;
    };
    Logger.prototype.log = function (message, details, opts) {
        this.formatMessage('log', message, details, opts);
    };
    Logger.prototype.debug = function (message, details, opts) {
        this.formatMessage('debug', message, details, opts);
    };
    Logger.prototype.info = function (message, details, opts) {
        this.formatMessage('info', message, details, opts);
    };
    Logger.prototype.warn = function (message, details, opts) {
        this.formatMessage('warn', message, details, opts);
    };
    Logger.prototype.error = function (message, details, opts) {
        this.formatMessage('error', message, details, opts);
    };
    Logger.prototype.formatMessage = function (level, message, details, opts) {
        var formatters = [this.defaultFormatter.bind(this)];
        if (this.config.formatters) {
            formatters = __spreadArrays(this.config.formatters, [this.defaultFormatter.bind(this)]);
        }
        this.callNextFormatter(formatters, level, message, details, opts);
    };
    Logger.prototype.callNextFormatter = function (formatters, level, message, details, opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        var formatter = formatters[0], remainingFormatters = formatters.slice(1);
        if (!formatter) {
            return this.logMessage(level, message, details, opts);
        }
        var next = function (newLevel, newMessage, newDetails, newOpts) {
            // next was called with params
            if (typeof newLevel !== 'undefined') {
                _this.callNextFormatter(remainingFormatters, newLevel, newMessage, newDetails, newOpts);
            }
            else {
                _this.callNextFormatter(remainingFormatters, level, message, details, opts);
            }
        };
        formatter(level, message, details, opts, next);
    };
    Logger.prototype.logRank = function (level) {
        switch (level) {
            case 'log':
                return 0;
            case 'debug':
                return 1;
            case 'info':
                return 2;
            case 'warn':
                return 3;
            case 'error':
                return 4;
            default:
                return -1; // for invalid logLevel
        }
    };
    return Logger;
}());
exports.Logger = Logger;
